// extracted by mini-css-extract-plugin
export default {"signup-container":"signUpPage_signup-container__dGhAG","form-group":"signUpPage_form-group__TzAxH","signin-prompt":"signUpPage_signin-prompt__7b3Gx"};